module.exports = __webpack_public_path__ + "static/media/done.4e2ef4dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/done.svg
// module id = 467
// module chunks = 0